import { Grid, TextField } from '@material-ui/core';
import { useState } from 'react';
import { SubmitHandler, useForm } from 'react-hook-form';
import { useHistory } from 'react-router-dom';
import { AuthService, PasswordResetModel } from '../api/auth';
import LoadingSpinner from '../dashboard/components/LoadingSpinner';
import Page from './layouts/Page';
import formStyles from './styles/Forms.module.scss';

const ResetPassword = ({ location }: any) => {
  const history = useHistory();

  const token = location.search.split('token=')[1].split('&')[0];
  const email = location.search.split('email=')[1].split('&')[0];

  const [isLoading, setIsLoading] = useState(false);

  const { register, handleSubmit, setError, formState, watch } = useForm<PasswordResetModel & { confirmPassword: string }>();

  const reset: SubmitHandler<PasswordResetModel> = (data) => {
    setIsLoading(true);

    AuthService.resetPasswordWithToken({ newPassword: data.newPassword, token, email })
      .then((res) => {
        history.push('/login');
      })
      .catch((err) => {
        setIsLoading(false);
        if (err?.response?.status === 400) {
          setError('newPassword', { type: 'manual', message: '' });
        }
      });
  };

  return (
    <Page>
      {isLoading && <LoadingSpinner attachToRoot />}
      <h1>Enter your new password</h1>
      <Grid component="form" onSubmit={handleSubmit(reset)} noValidate container flexDirection="column" sx={{ marginTop: '1rem' }}>
        <Grid item container spacing={2}>
          <Grid item xs={6} md={6}>
            <TextField
              label="Password"
              InputProps={{ type: 'password' }}
              {...register('newPassword', { required: { value: true, message: 'Please enter your password' } })}
              helperText={formState.errors.newPassword?.message}
              error={!!formState.errors.newPassword}
            />
          </Grid>
        </Grid>
        <Grid item container spacing={2}>
          <Grid item xs={6} md={6}>
            <TextField
              label="Confirm Password"
              InputProps={{ type: 'password' }}
              {...register('confirmPassword', {
                required: { value: true, message: 'Confirm Password is required' },
                validate: (value) => value === watch('newPassword') || 'Passwords do not match',
              })}
              helperText={formState.errors.confirmPassword?.message}
              error={!!formState.errors.confirmPassword}
            />
          </Grid>
        </Grid>
        <Grid item container sx={{ mb: 3 }}>
          <Grid item xs={6}>
            <button disabled={isLoading} type="submit" className={formStyles.submit} style={{ width: '100%' }}>
              Reset Password
            </button>
          </Grid>
        </Grid>
      </Grid>
    </Page>
  );
};

export default ResetPassword;
